import { AfterViewInit, Component, DestroyRef, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute, Router } from "@angular/router";
import { hasIndex } from "@ankaadia/ankaadia-shared";
import { TermsAndConditionsForConsentFragment } from "@ankaadia/graphql";
import { isEmpty, isNil } from "lodash";
import { NewUiTermsAndConditionsComponent } from "../../features/terms-and-conditions/new-ui-terms-and-conditions.component";
import { TermsAndConditionsService } from "../../features/terms-and-conditions/terms-and-conditions.service";
import { TranslateDirective } from "../../shared/transloco/translate.directive";

@Component({
  selector: "new-ui-terms-and-conditions-page",
  templateUrl: "./new-ui-terms-and-conditions-page.component.html",
  imports: [TranslateDirective, NewUiTermsAndConditionsComponent],
  host: {
    "(window:resize)": "onWindowResize()",
  },
})
export class NewUiTermsAndConditionsPageComponent implements OnInit, AfterViewInit {
  protected readonly isNil = isNil;

  protected previousUrl: string | null = null;
  protected selectedConsentIndex: number | null = null;
  protected consents: TermsAndConditionsForConsentFragment[] = [];
  protected get termsAndConditions(): TermsAndConditionsForConsentFragment {
    return hasIndex(this.consents, this.selectedConsentIndex) ? this.consents[this.selectedConsentIndex] : null;
  }

  constructor(
    private readonly destroyRef: DestroyRef,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly service: TermsAndConditionsService
  ) {
    const nav = this.router.getCurrentNavigation();
    this.previousUrl = nav?.extras?.state?.["from"] || null;
  }

  ngOnInit(): void {
    this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      const consentGiverId = params["consentGiverId"];
      const organizationId = params["organizationId"];
      const consentIdentifier = params["consentIdentifier"];

      this.service
        .getOutStandingConsents({ consentGiverId, organizationId, consentIdentifier }, consentIdentifier == null) // in case we do not have specific consent, we can use cache-only because the this consents have already been loaded
        .subscribe((consents) => {
          this.selectedConsentIndex = 0;
          if (isEmpty(consents)) {
            this.goBack();
            return;
          }

          this.consents = consents;
        });
    });
  }

  onWindowResize(): void {
    this.setViewportHeight();
  }

  ngAfterViewInit(): void {
    this.setViewportHeight();
  }

  setViewportHeight(): void {
    const { innerWidth, innerHeight } = window;
    const width = innerWidth < 800 ? innerWidth : innerWidth * 0.8;
    const height = innerWidth < 800 ? innerHeight : innerHeight * 0.8;

    document.documentElement.style.setProperty("--consent-width", `${width}px`);
    document.documentElement.style.setProperty("--consent-height", `${height}px`);
  }

  protected processConsent(_consentGiven: boolean): void {
    this.selectedConsentIndex += 1;
    if (!hasIndex(this.consents, this.selectedConsentIndex)) {
      this.goBack();
    }
  }

  protected goBack(): void {
    if (this.previousUrl) {
      void this.router.navigateByUrl(this.previousUrl);
    } else {
      void this.router.navigate(["/"]);
    }
  }
}
